export const LOGIN = 'login';
export const LOGOUT = 'logout';
export const TOKEN = 'token';
export const CURRENTUSER = 'currentUser';
export const PERMISSIONS = 'permissions';
export const FILECOMMAND = 'fileCommand';
export const SELECTMENU = 'selectMenu';
export const TESTREPORT = 'testReport';
export const CURRENTLESSON = 'currentLesson';
export const UPLOADCODE = 'uploadCode';
export const EXPANDPREVIEWCODE= 'expandPreviewCode';
export const CANCELMENU= 'cancelMenu';
export const ISPRIVACY = 'isPrivacy';
export const ISEYE = 'isEye';
export const HASOLDENTRANCE = 'hasOldEntrance';
export const PLAYFLAG = 'playFlag';
export const ISSHAKE = 'isShake';



// WEBPACK FOOTER //
// ./src/store/types.js